module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" class="header-wrap" data-toggle="expand-spoiler"><header><h5 class="module-title">'+
((__t=( i18n.tc( "ControlMap", "Map" )))==null?'':__t)+
'</h5><i class="icon icon-material icon-expand"></i></header></a><div class="expand-spoiler';
 if ( isOpen ) { 
__p+=' open';
 } 
__p+='" data-container="expand-spoiler"><div class="expand-content"><div class="map-wrapper block" data-container="map-container"></div><fieldset class="button-wrap"><button class="primary" data-click="map-refresh">'+
((__t=( i18n.tc( "UnitMap", "Refresh" ) ))==null?'':__t)+
'</button></fieldset></div></div>';
}
return __p;
};
